export const deComponentLibraryBannerComponents = {
    componentLibrary: {
        molecules: {
            appBar: {
                banner: {
                    showDetails: 'Details anzeigen',
                    hideDetails: 'Details ausblenden',
                    close: 'Banner schließen',
                },
            },
        },
    },
}
